import {Button, Paper} from '@material-ui/core';
import {Async, Loaded} from 'Core/models/Async';
import {Email, eqEmail, ValidEmail} from 'Core/models/Email';
import {Either, fold, isRight, left, right} from 'fp-ts/lib/Either';
import {identity} from 'fp-ts/lib/function';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useState} from 'react';
import EmailInput from 'Shared/components/EmailInput';
import withSelectedAgency, {WithSelectedAgencyProps} from 'Shared/components/withSelectedAgency';
import {saveEmail} from 'Users/ducks/userAccount';

type UserEmailSectionProps = {
  userId: string;
  asyncEmail: Either<Email, Email>;
  onChange: (email: Async<Either<Email, Email>>) => void;
  saveEmail: typeof saveEmail;
} & WithSelectedAgencyProps;

const UserEmailSection = (props: UserEmailSectionProps) => {
  const {selectedAgency} = props;
  const email = pipe(props.asyncEmail, fold(identity, identity));
  const [originalEmail, setOriginalEmail] = useState(email);
  const isEditing = isRight(props.asyncEmail);
  const hasEmailChanged = !eqEmail.equals(originalEmail, email);
  return (
    <Paper className="user-profile__user-info-section">
      <div className="user-info-section__header">
        <h3>Email</h3>
      </div>
      <div className="user-info-section__name-fields">
        <EmailInput
          className="user-info-section__profile-input"
          label="Email"
          disabled={!isEditing}
          onChange={newEmail => props.onChange(new Loaded(right(newEmail)))}
          email={email}
        />
      </div>
      <div className="user-info-section__actions-container">
        {isEditing ? (
          <>
            <Button
              variant="contained"
              className="user-info-section__cancel-user-information-button"
              onClick={() => {
                props.onChange(new Loaded(left(originalEmail)));
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={!hasEmailChanged || !(email instanceof ValidEmail)}
              color="primary"
              variant="contained"
              className="user-info-section__save-user-information-button"
              onClick={() => props.saveEmail(props.userId, email as ValidEmail, selectedAgency?.encryptedIdentifier)}
            >
              Save
            </Button>
          </>
        ) : (
          <Button
            className="user-info-section__edit-button"
            color="primary"
            variant="contained"
            onClick={() => props.onChange(new Loaded(right(email)))}
          >
            Edit&nbsp;&nbsp;
            <i className="fa fa-edit" />
          </Button>
        )}
      </div>
    </Paper>
  );
};

export default withSelectedAgency(UserEmailSection);
